import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4.33338 4.99948C4.33367 3.34283 5.67673 2 7.33338 2H13.0004V4H7.33338C6.78117 4 6.33348 4.44761 6.33338 4.99983L6.33226 11.5H4.33997L0.585938 7.44565L2.05346 6.08683L4.33277 8.54849L4.33338 4.99948ZM7.99911 6H22.9991V21H7.99911V6Z"}}]};

const AnticlockwiseFilled = Vue.extend<IconProps>({
  name: 'AnticlockwiseFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'anticlockwise-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default AnticlockwiseFilled;
